import {Sha256} from '@aws-crypto/sha256-js';
import {fromCognitoIdentityPool} from '@aws-sdk/credential-providers';
import {HttpRequest} from '@aws-sdk/protocol-http';
import {SignatureV4} from '@aws-sdk/signature-v4';
import {Auth} from 'aws-amplify';
import awsExports from '../aws-exports';

const region = awsExports.aws_cognito_region;
const identityPoolId = awsExports.aws_cognito_identity_pool_id;

export async function executeLambdaFnUrl<T>({
  fnUrl,
  body,
}: {
  fnUrl: string;
  body: object;
}): Promise<T> {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  const iss = session.getIdToken().payload.iss as string;
  const providerName = iss.replace('https://', '');
  const credentials = fromCognitoIdentityPool({
    identityPoolId,
    clientConfig: {region},
    logins: {[providerName]: idToken},
  });

  const url = new URL(fnUrl);
  const signer = new SignatureV4({
    credentials,
    region,
    service: 'lambda',
    sha256: Sha256,
  });

  const requestToBeSigned = new HttpRequest({
    method: 'POST',
    protocol: url.protocol,
    hostname: url.hostname,
    path: url.pathname,
    headers: {
      'content-type': 'application/json',
      'x-prop-dock-id-token': idToken, // NOTE: Since SignatureV4 uses the Authorization header, JWT is passed as a custom header
      host: url.host,
    },
    body: JSON.stringify(body),
  });

  const signed = await signer.sign(requestToBeSigned);
  const request = new Request(fnUrl, signed);

  const response = await fetch(request);
  if (!response.ok) {
    const err = new Error(
      `Error Occurred ${response.status} ${response.statusText}`,
    );
    throw err;
  }
  const responseBody = (await response.json()) as T;

  return responseBody;
}
